import { Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Paper, Toolbar } from '@mui/material';
import React, { useState } from 'react';
import Draggable from 'react-draggable';
import CloseIcon from '@mui/icons-material/Close';
import OpenInFull from '@mui/icons-material/OpenInFull';
import Minimize from '@mui/icons-material/Minimize';
import ErrorBoundary from '../../ErrorBoundary';

function PaperComponent(props) {
    return (
        <Draggable
            handle="#dialog-title"
            cancel={'[class*="MuiDialogContent-root"]'}
        >
            <Paper {...props} />
        </Draggable>
    );
}

const ECDialog = ({ title, children, visible, onClose, fullWidth = 400, maxWidth, closeText = 'Close', maximisable = false }) => {

    const [isFullScreen, setIsFullScreen] = useState(false);

    const handleToggleFullScreen = () => {
        setIsFullScreen(!isFullScreen);
    };

    return (
        <Dialog
            open={visible}
            onClose={onClose}
            scroll={"paper"}
            fullWidth={fullWidth}
            maxWidth={isFullScreen ? '100%' : maxWidth}
            fullScreen={isFullScreen}
            PaperComponent={PaperComponent}
            BackdropProps={{
                sx: {
                    backgroundColor: "rgba(0, 0, 0, 0.2)", // Darker backdrop
                },
            }}
        >
            <Toolbar disableGutters variant='dense' sx={{ m: 0, p: 0, display: 'flex' }}>
                <DialogTitle id="dialog-title" sx={{ cursor: 'move', flexGrow: 1 }}>{title}</DialogTitle>
                {maximisable && <IconButton onClick={handleToggleFullScreen} sx={{borderRadius: 0}}>
                    {isFullScreen ? <Minimize /> : <OpenInFull />}
                </IconButton>}
                <IconButton onClick={onClose} sx={{borderRadius: 0}}>
                    <CloseIcon />
                </IconButton>
            </Toolbar>
            <DialogContent dividers sx={{paddingX: 2, paddingY: 0}}>
                <ErrorBoundary>
                    {children}
                </ErrorBoundary>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>{closeText}</Button>
            </DialogActions>
        </Dialog>
    );
};

export default ECDialog;
